if (!customElements.get('bfcm-product-bundle')) {
  customElements.define('bfcm-product-bundle', class BfcmProductBundle extends HTMLElement {
    constructor() {
        super();
        // Fixed typo: quanity -> quantity
        this.quantityBoxOpeners = this.querySelectorAll(".quanity-opener");
        this.quantityButtons = this.querySelectorAll(".quantity-button");
        this.mainProductVariantId = this.dataset.id; // Fixed typo: Varaind -> Variant
        this.maxNumber = parseInt(this.dataset.maxproduct) || 0;
        this.quantityCounter = 0;
        this.atcButton = this.querySelector(".bfcm-bundle-atc");
        this.bundleJSON = JSON.parse(this.querySelector(".bundle-json-format").textContent);
        this.variantSelectors = this.querySelectorAll(".bundle-variant-input");
        this.miniCart = document.querySelector('mini-cart');
        this.setupEventListeners();
    }
    
    setupEventListeners(){
        this.quantityBoxOpeners.forEach((el) => {
            el.addEventListener('click', this.openQuantityBox.bind(this));
        });
        
        this.variantSelectors.forEach((el) => {
            el.addEventListener('change', this.onVariantChange.bind(this));
        });
        
        this.quantityButtons.forEach((el) => {
            el.addEventListener('click', () => {
                this.onQuantityChange(el);
            });
        });
        
        this.atcButton.addEventListener("click", this.addToCart.bind(this));
       
    }
   
    
    async addToCart(){
        if(this.quantityCounter != this.maxNumber){
            return false;
        }
        
        this.atcButton.setAttribute('disabled', true);
        this.atcButton.classList.add('loading');
        
        const bundleId = new Date().getTime(); 
        let items = [];
        
        // Collect bundle items
        this.querySelectorAll(".bundle-item").forEach((bundle_item) => {
            const quantity = Number(bundle_item.querySelector(".custom-qty-box-input").value);
            if(quantity > 0){
                const variant_id = bundle_item.querySelector('.bundle-variant-input').value;
                items.push({
                    id: variant_id,
                    quantity: quantity,
                    properties: {
                        "_ismain": 0,
                        "_bundleid": bundleId,
                        "_priceincludeditem": 1
                    }
                });
            }
        });
        
        // Add bundle offers
        if(this.bundleJSON.bundle_offerts && this.bundleJSON.bundle_offerts.length > 0){
            for(let i in this.bundleJSON.bundle_offerts){
                if (this.bundleJSON.bundle_offerts[i].available === 'true'){
                    items.push({
                        id: this.bundleJSON.bundle_offerts[i].id,
                        quantity: 1,
                        properties: {
                            "_ismain": 0,
                            "_bundleid": bundleId,
                            "_priceincludeditem": 0,
                            "_bundleofferetitem": 1
                        }
                    });
                }
                
            }
        }
        
        // Add main product
        items.push({
            id: this.dataset.id,
            quantity: 1,
            properties: {
                "_ismain": 1,
                "_bundleid": bundleId,
                "_priceincludedbundle": 1
            }
        });
        
        const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
        const body = JSON.stringify({
            items: items,
            sections: sections,
            sections_url: window.location.pathname
        });
        
        try {
            const response = await fetch(`${theme.routes.cart_add_url}`, { 
                ...fetchConfig('javascript'), 
                body 
            });
            const data = await response.json();
            
            if (data.status === 422) {
                document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
                    detail: {
                        errorMessage: data.description
                    }
                }));
            } else {
                this.miniCart && this.miniCart.renderContents(data);
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data
                    }
                }));
            }
        } catch (e) {
            console.error(e);
        } finally {
            if(this.closest('.custom-modal__centered.active')){
                this.closest('.custom-modal__centered.active').classList.remove("active");
                document.body.classList.remove("bfcm-overflow-hidden");
            }
            this.atcButton.classList.remove('loading');
            this.atcButton.removeAttribute('disabled');
        }
    }
    
    onVariantChange(evt){
        this.updateButtonPrice();
    }
    
    onQuantityChange(button){
        const inputElement = button.parentElement.querySelector('.custom-qty-box-input');
        const quantityDisplayElement = button.parentElement.querySelector('.display-qty');
        const currentValue = parseInt(inputElement.value) || 0;
        
        if(button.classList.contains('plus')){
            if(this.quantityCounter < this.maxNumber){
                inputElement.stepUp();
                this.quantityCounter++;
            }
        } else {
            if(currentValue > 0){
                inputElement.stepDown();
                this.quantityCounter--;
                
                if(parseInt(inputElement.value) <= 0){
                    button.parentElement.classList.add("hidden");
                    button.parentElement.previousElementSibling.classList.remove("hidden");
                }
            }
        }
        
        quantityDisplayElement.textContent = inputElement.value;
        this.updateStateAndValue();
    }
    
    updateStateAndValue(){
        if(this.quantityCounter == this.maxNumber){
            this.querySelectorAll(".bundle-item").forEach((el) => {
                const inputValue = parseInt(el.querySelector(".custom-qty-box-input").value) || 0;
                
                if(inputValue > 0){
                    el.querySelector("button.plus").setAttribute("disabled", "disabled");
                    el.querySelector("button.minus").removeAttribute("disabled");
                } else {
                    el.classList.add("opacity-5");
                    el.querySelector("button.plus").setAttribute("disabled", "disabled");
                    el.querySelector("button.minus").setAttribute("disabled", "disabled");
                   // el.querySelector(".quanity-opener").setAttribute("disabled", "disabled");
                }
            });
            this.atcButton.removeAttribute("disabled");
            this.atcButton.querySelector(".atc-total-counter").classList.add("hidden");
            this.atcButton.querySelector(".atc-total-price").classList.add("hidden");
        } else {
            this.querySelectorAll(".bundle-item").forEach((el) => {
                el.querySelector("button.plus").removeAttribute("disabled");
                el.classList.remove("opacity-5");
                
                /*if(!el.classList.contains("opacity-6")){
                    let selected_values = Array.from(el.querySelectorAll(".option-selector")).map(el => el.value);
                    let is_empty = selected_values.some(val => val === '');
                    
                    if(is_empty === false){
                        el.querySelector(".quanity-opener").removeAttribute("disabled");
                    }
                }*/
            });
            this.atcButton.querySelector(".atc-total-counter").textContent = ` - ${this.quantityCounter}/${this.maxNumber}`;
            this.atcButton.setAttribute("disabled", "disabled");
            this.atcButton.querySelector(".atc-total-counter").classList.remove("hidden");
            this.atcButton.querySelector(".atc-total-price").classList.add("hidden");
        }
        
        this.updateButtonPrice();
    }
    
    updateButtonPrice() {
        const price = Array.from(this.querySelectorAll(".custom-qty-box-input")).reduce((sum, el) => {
            const productId = el.dataset.pid;
            const findBundleItem = this.bundleJSON.bundle_items.find(item => item.id == productId);
            const mainItemElement = this.querySelector(`.bundle-item[data-pid="${productId}"]`);
        
           if (findBundleItem && mainItemElement) {
                const variantInput = mainItemElement.querySelector(".bundle-variant-input");
                
                // FIX: Get the value from the input element
                if (variantInput) {
                    const variantId = variantInput.value;
                    const findVariant = findBundleItem.variants.find(variant => variant.id == variantId);
                    
                    if (findVariant) {
                        const itemPrice = findVariant.price * Number(el.value);
                        return sum + itemPrice;
                    }
                }
            }
            
            return sum;
        }, 0);
        
        const formattedPrice = theme.Currency.formatMoney(price, window.shopSettings.moneyFormat);
        this.atcButton.querySelector(".atc-total-price").textContent = formattedPrice.replace(/<[^>]*>/g, '');
    }
    
    openQuantityBox(evt){
        const button = evt.target;
        button.classList.add("hidden");
        button.parentElement.querySelector(".bundle-quantity-box-wrapper").classList.remove("hidden");
        button.parentElement.querySelector(`.bundle-quantity-box-wrapper .quantity-button.plus`).click();
    }
  });
}